import type { PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

export const palette: PaletteOptions = {
  // Figma coupon modal overlay: black, 50% opacity (unnamed fill).
  modal_backdrop: 'rgba(0, 0, 0, 0.5)',
  // Figma deactivation modal shadow: Dark at 20% opacity (unnamed color).
  modal_shadow: 'rgba(51, 82, 62, 0.2)',
  backgroundColor: '#F5F5F5',
  bgDark: '#CBCFCC',
  pale_accent: '#CFDEC1',
  light_dark: '#9A9E9B',
  semi_dark: '#59635D',
  dark: '#33523E',
  white_100: '#FFFFFF',
  black_100: '#000000',
  black_15: 'rgba(0,0,0,0.15)',
  white_90: '#FFFFFFE6',
  white_20: 'rgba(255,255,255,0.2)',
  white_50: 'rgb(255 255 255 / 0.5)',
  white_80: 'rgba(255,255,255,0.8)',
  accent_text: '#08A700',
  accent_text_30: 'rgba(8,167,0,0.3)',
  accent: '#81C73D',
  accent_yellow: '#FFEA00',
  accent_40: 'rgba(129,199,61,0.4)',
  accent_25: '#81C73D40',
  error: { '500': '#E34A1F', main: '#E34A1F' } as unknown as PaletteColorOptions,
  attention: '#EF8915',
  attention_dark: '#EA6D06',
  juicy_green_grad: `radial-gradient(77.94% 100% at 47.16% 0%, #A2E85E 2.38%, #7ACE29 100%)`,
  neon_blue_20: 'rgb(19 247 255 / 0.2)',
  neon_blue_100: '#13F7FF',
  neon_green_20: 'rgb(0 255 119 / 0.2)',
  neon_green_100: '#00FF77',
  neon_yellow_20: 'rgb(247 224 39 / 0.2)',
  neon_yellow_100: '#F7E027',
  purple: '#7D7DFF',
  purple_20: 'rgb(125 125 255 / 0.2)',
  blue: '#238CFC',
  blue_30: 'rgb(35 140 252 / 0.3)',
};
